export default __webpack_public_path__ + "static/media/soundcloud-logo.492f02b6.jpg";